import React from 'react'
import {Button, Dialog} from 'components/ui'

const ConfirmDialog = ({
    title,
    children,
    onCancel,
    onConfirm,
    cancelText = 'Cancel',
    confirmText = 'Confirm',
    disabled,
    ...rest
}) => {
    const handleCancel = () => {
        onCancel?.()
    }

    const handleConfirm = () => {
        onConfirm?.()
    }

    return (
        <Dialog className="confirm-dialog" contentClassName="confirm-dialog-content" {...rest}>
            <p className="confirm-dialog-v2-title">{title}</p>
            <div className="confirm-dialog-v2-text">{children}</div>
            <div className="flex justify-end gap-3">
                <Button type="button" className="font-bold" onClick={handleCancel} disabled={disabled}>
                    {cancelText}
                </Button>
                <Button type="button" className="font-bold" variant="solid" onClick={handleConfirm} disabled={disabled}>
                    {confirmText}
                </Button>
            </div>
        </Dialog>
    )
}

export default ConfirmDialog
